







































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import moment from "moment";
import PatientEditor from "@/components/patient/PatientEditor.vue";

@Component({
  components: {
    PatientEditor
  },
  filters: {
    phone: function(phone: string) {
      if (!phone) return null;
      const parsed = parsePhoneNumberFromString(phone, "US");
      if (parsed) return parsed.formatNational();
      return phone;
    }
  }
})
export default class PatientViewer extends Vue {
  @Prop(Number) readonly patientId!: number;
  patient: any = null;
  async getPatient() {
    try {
      this.patient = await this.$store.dispatch(
        "patients/getPatient",
        this.patientId
      );
    } catch (error) {
      console.log(error);
    }
  }
  getLocation() {
    const address = this.patient.address.trim();
    if (address) {
      window.open("https://maps.google.com/?q=" + address, "_blank");
    }
  }
  mounted() {
    if (this.patientId) this.getPatient();
  }
}
